package com.mgacreative.hotel.domain.repository

import com.mgacreative.hotel.core.network.SupabaseNetworkClient
import com.mgacreative.hotel.core.tenant.TenantSession
import com.mgacreative.hotel.domain.model.Staff
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

interface StaffRepository {
    val staffList: StateFlow<List<Staff>>
    suspend fun loadStaff()
    suspend fun addStaff(staff: Staff): Boolean
}

class StaffRepositoryImpl(
    private val networkClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession
) : StaffRepository {
    private val _staffList = MutableStateFlow<List<Staff>>(emptyList())
    override val staffList: StateFlow<List<Staff>> = _staffList.asStateFlow()

    override suspend fun loadStaff() {
        if (tenantSession.isDemoMode) {
            _staffList.value = com.mgacreative.hotel.domain.demo.DemoDataProvider.staffState.value
            return
        }
        try {
            val tenantId = tenantSession.currentTenantId
            if (tenantId != null) {
                val response = networkClient.client.postgrest["staff"]
                    .select {
                        filter {
                            eq("tenant_id", tenantId)
                        }
                    }.decodeList<Staff>()
                _staffList.value = response
            }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
        }
    }

    override suspend fun addStaff(staff: Staff): Boolean {
        if (tenantSession.isDemoMode) {
            val newStaff = staff.copy(id = "st-${(100..999).random()}", tenant_id = com.mgacreative.hotel.domain.demo.DemoDataProvider.DEMO_TENANT_ID)
            com.mgacreative.hotel.domain.demo.DemoDataProvider.staffState.value = com.mgacreative.hotel.domain.demo.DemoDataProvider.staffState.value + newStaff
            _staffList.value = com.mgacreative.hotel.domain.demo.DemoDataProvider.staffState.value
            return true
        }
        return try {
            val tenantId = tenantSession.currentTenantId
            if (tenantId != null) {
                val staffWithTenant = staff.copy(tenant_id = tenantId)
                networkClient.client.postgrest["staff"]
                    .insert(staffWithTenant)
                loadStaff() // Refresh list
                true
            } else {
                false
            }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            false
        }
    }
}
